import axios from "../../../../../axios";
import React, { useState } from "react";
import "./editDelete.css";

const DeleteReply = ({
  setReply,
  replyId,
  setDelet,
  setDeleted,
  setFilter,
  filter,
  queryId,
}) => {
  let user_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isInProgress, setIsInProgress] = useState(false);
  const handleDelete = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.delete(`/api/v1/query/reply/delete/${replyId}`, {
        data: { user_id },
      });
      if (res) {
        setFilter((prevState) => ({ ...prevState, page: 1 })); 
        setDeleted((prev) => !prev);
      }
      setReply([]);
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  return (
    <>
      <div className=" delete_reply_transprant_body ">
        <img
          src="/images/cross-circle3.svg"
          className=" delete_reply_close_btn"
          alt=""
          onClick={(e) => setDelet(false)}
        />
        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_reply_container shadow">
          <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
            <span className="mt-4 mb-5 delete_reply_text">
              Are you sure you want to delete this Reply?
            </span>
            <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
              <button
                disabled={isInProgress}
                className="btn btn-danger col-sm-5  reply_delete_btn"
                onClick={handleDelete}
              >
                Yes
              </button>
              <button
                disabled={isInProgress}
                className="btn btn-danger col-sm-5 reply_delete_btn no"
                onClick={(e) => setDelet(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteReply;
